import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ({ faqs }: { faqs: FAQItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-question-line text-xs"></i>
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            你关心的<span className="text-secondary-600">问题</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于一起草视频，这里有你想要的答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer group"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === idx ? 'bg-primary-500 rotate-45' : 'bg-background-200'
                }`}>
                  <i className={`text-xs ${openIndex === idx ? 'text-white' : 'text-foreground-600'} ri-add-line`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}